import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'antd';
import useApi from '../../hooks/useApi';
import { isEmpty } from '../../generalFunctions';
import YouTube from 'react-youtube';

const HomeVideoGallery = () => {
    const [response, request] = useApi("/website/home/videos?limit=4");
    const [videos, setVideos] = useState([]);

    useEffect(() => {
        request();
    }, []);//eslint-disable-line

    useEffect(() => {
        if (!isEmpty(response.data) && !response.error && !response.isLoading) {
            setVideos(response.data);
        }

    }, [response]);

    return (
        <Row gutter={[8, 8]}>
            {videos.map(video => <Col xl={6} lg={6} md={12} sm={24} xs={24} key={video.id}>
                <Card>
                    <YouTube
                        videoId={video.video_id}
                        id={video.id}
                        opts={{
                            height: "165",
                            width: "100%",
                            playerVars: {
                                rel: 0,
                            },
                        }}
                    />
                    <p>{video.title}</p>
                </Card>
            </Col>)}
        </Row>
    );
}

export default HomeVideoGallery;